import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: '[app-tr-inventory]',
  template: `
  <td class="align-middle">
    <div class="d-flex">
      <div>
        <img src="{{ stock?.thumbnail }}" style="max-width: 20px;"> 
      </div>
      {{stock?.name}}
    </div>
  </td>
  <td class="align-middle text-center">{{ stock?.sku }}</td>
  <td class="align-middle text-center">{{ stock?.description }}</td>  
  <td class="align-middle text-center">{{ stock?.quantity}}</td>
  <td class="align-middle text-center">{{ stock?.minimum_threshold}}
    <span *ngIf="stock?.quantity >= stock?.minimum_threshold" class="badge badge-pill bg-success">Ok</span>
    <span *ngIf="stock?.quantity < stock?.minimum_threshold" class="badge badge-pill bg-danger">No Ok</span>
  <td class="align-middle text-center">{{ stock?.profile?.name }}</td>
  <td class="align-middle text-center">{{ stock?.unit_of_measure }}</td>  
  <td class="align-middle text-center">{{ stock?.updated_at | date: 'YYYY-MM-dd' }}</td>
  <td class="align-middle text-center">{{ stock?.unit_price | currency }}</td>
  `,
  styleUrls: []
})
export class TrInventoryComponent {
  @Input() stock: any;
  @Input() profile: any;
  @Input() permissions: any;

}
